import {
    Box,
    Button,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    Typography,
} from '@mui/material';
import React, { ChangeEvent, FormEvent } from 'react';
import { COLORS } from '../../Constants/styles';

const departments = [
    'Summer Camp', 'School Break Camp', 'Swim Camp', 'Swimming',
    'Water Exercise', 'Soccer', 'Basketball', 'Baseball', 'Gymnastics',
    'Pickleball', 'Fitness', 'Daycare', 'Birthday Parties',
    'Membership', 'Surface Rentals', 'Other'
];

export const CareerForm = () => {
    const [formData, setFormData] = React.useState({
        department: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        comments: '',
    });

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            console.log('Form data:', formData);
            const response = await fetch('/api/apply', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Form submitted successfully');
                // You could reset form or show success message
                setFormData({
                    department: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    zipCode: '',
                    comments: '',
                });
            } else {
                console.error('Form submission failed');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };


    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 4, maxWidth: 800, mx: 'auto', backgroundColor: COLORS.white, borderRadius: 4, height: "auto" }}>
            <Typography variant="h4" gutterBottom sx={{
                textAlign: 'center', 
                mb: 2,
            }}>
                Your Information
            </Typography>

            <Divider sx={{ my: 4 }} />
            <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                        <InputLabel>Department</InputLabel>
                        <Select
                            name="department"
                            value={formData.department}
                            onChange={handleChange}
                            label="Department"
                        >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            {departments.map((dept) => (
                                <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        fullWidth
                        name="firstName"
                        label="First Name"
                        placeholder="e.g. John"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        fullWidth
                        name="lastName"
                        label="Last Name"
                        placeholder="e.g. Smith"
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        fullWidth
                        type="email"
                        name="email"
                        label="Email"
                        placeholder="e.g. john@youremail.com"
                        value={formData.email}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        fullWidth
                        type="tel"
                        name="phone"
                        label="Phone"
                        placeholder="e.g. 123 1800-567-8990"
                        inputProps={{
                            pattern: "[0-9()#&+*=\\-.]+",
                            title: "Only numbers and phone characters (#, -, *, etc) are accepted."
                        }}
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        fullWidth
                        name="zipCode"
                        label="ZIP Code"
                        placeholder="e.g. 10001"
                        value={formData.zipCode}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        name="comments"
                        label="Why do you want to join Grassroots?"
                        placeholder="Enter your message here"
                        value={formData.comments}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    {/* <AccentButton
                        label="Apply Now"
                        href="/"
                    /> */}
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            bgcolor: COLORS.accentLime,
                            color: COLORS.accentDarkGreen,
                            border: `1px solid ${COLORS.accentDarkGreen}`,
                            fontWeight: 600,
                            fontFamily: "'Big Shoulders Text', sans-serif",
                            textDecoration: 'none',
                            textTransform: 'uppercase',
                            '&:hover': {
                                bgcolor: COLORS.accentDarkGreen,
                                color: COLORS.accentLime,
                                border: `1px solid ${COLORS.accentLime}`,
                            },
                        }}
                    >
                        Apply Now
                    </Button>
                    {/* <CustomTextButton label="Learn More" href="/about" /> */}
                </Grid>
            </Grid>
        </Box>
    );
}
